<div id="program">
    <div class="container-fluid px-lg-5">
        <div class="row">
            <div class="col-12 text-center">
               <h2 class="font-weight-bold">Programs Made For You</h2>
            </div>
        </div>
        
        <div class="row justify-content-center mt-5">
            <!-- UNDERGRADUATE (UG) CARD -->
            <div class="col-lg-6 col-md-12 mb-4 d-flex align-items-stretch">
                <div class="premium-card ug-card w-100">
                    <div>
                        <!-- Header -->
                        <div class="card-header-block">
                            <div class="icon-container">
                                <img src="/assets/svg/courses/1.svg" alt="UG Icon">
                            </div>
                            <div class="title-meta">
                                <h3>Undergraduate Courses</h3>
                                <span class="subtitle">10 Professional Degree Programs</span>
                            </div>
                        </div>

                        <!-- Course Grid -->
                        <div class="row course-grid-row">
                            <!-- Left Column -->
                            <div class="col-6 divider-right">
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.A. (Bachelor of Arts)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.Sc. (Physical Sciences)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.C.A. (Computer Applications)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.B.A. (Business Admin.)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.P.A. (Performing Arts) <span class="tag-new">NEW</span></span>
                                </div>
                            </div>
                            
                            <!-- Right Column -->
                            <div class="col-6 divider-left">
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.Com. (Commerce)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.A.J.M.C. (Journalism)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.P.Ed. (Physical Ed.)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>D.P.Ed. (Diploma in P.Ed.)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>B.Sc. (Sports Ed.) <span class="tag-new">NEW</span></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Actions Footer -->
                    <div class="action-footer">
                        <a routerLink="/academics/programs" class="btn-know-more">
                            Know More <i class="fa fa-arrow-right"></i>
                        </a>
                        <button class="btn-apply" (click)="openApplyForn()">Apply Now</button>
                    </div>

                    <!-- Glowing bubbles -->
                    <div class="circle-glow-1"></div>
                    <div class="circle-glow-2"></div>
                </div>
            </div>

            <!-- POSTGRADUATE (PG) CARD -->
            <div class="col-lg-6 col-md-12 mb-4 d-flex align-items-stretch">
                <div class="premium-card pg-card w-100">
                    <div>
                        <!-- Header -->
                        <div class="card-header-block">
                            <div class="icon-container">
                                <img src="/assets/svg/courses/3.svg" alt="PG Icon">
                            </div>
                            <div class="title-meta">
                                <h3>Postgraduate Courses</h3>
                                <span class="subtitle">5 Advanced Specializations</span>
                            </div>
                        </div>

                        <!-- Course Grid -->
                        <div class="row course-grid-row">
                            <!-- Left Column -->
                            <div class="col-6 divider-right">
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>M.A. (English)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>M.A. (Hindi)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>M.A. (Public Admin.)</span>
                                </div>
                            </div>
                            
                            <!-- Right Column -->
                            <div class="col-6 divider-left">
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>M.Sc. (Mathematics)</span>
                                </div>
                                <div class="course-item">
                                    <i class="fa-solid fa-check-double"></i>
                                    <span>M.Com. (Commerce)</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Actions Footer -->
                    <div class="action-footer">
                        <a routerLink="/academics/programs" class="btn-know-more">
                            Know More <i class="fa fa-arrow-right"></i>
                        </a>
                        <button class="btn-apply" (click)="openApplyForn()">Apply Now</button>
                    </div>

                    <!-- Glowing bubbles -->
                    <div class="circle-glow-1"></div>
                    <div class="circle-glow-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>
